export default __webpack_public_path__ + "resources/icons/n310-f1e0.webp";